module.exports = __webpack_public_path__ + "static/img/14.92bf378.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/14.png
// module id = GwGc
// module chunks = 0